var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:_vm.buttonClasses,attrs:{"disabled":_vm.disabled,"title":_vm.title},on:{"click":_vm.pageChange}},[(_vm.loading)?_c('div',[_vm._v("loading")]):_c('span',{domProps:{"innerHTML":_vm._s(_vm.html)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }